import { useEffect } from 'react';
import { useDeveloperStore } from '@/store/developerStore';
import { useUiStore } from '@/store/uiStore';
import { DeveloperPanel } from '@/developer/DeveloperPanel';
import { StatusBar } from '@/ui/layout/StatusBar';
import { BottomPanel } from '@/ui/panels/BottomPanel';
import { ComponentsPanel } from '@/ui/panels/ComponentsPanel';
import { PropertiesPanel } from '@/ui/panels/PropertiesPanel';
import { SceneView } from '@/ui/scene/SceneView';
import { AppToolbar } from '@/ui/toolbar/AppToolbar';
import { Toolbox } from '@/ui/editor/ladder/Toolbox';
import { LadderCanvas } from '@/ui/editor/ladder/LadderCanvas';
import { HMIEditor } from '@/ui/editor/hmi/HMIEditor';
import { HMIToolbox } from '@/ui/editor/hmi/HMIToolbox';
import { HMIRuntimeWindow } from '@/ui/editor/hmi/HMIRuntimeWindow';
import { WorkshopView } from '@/workshop/ui/WorkshopView';
import { ToastRegion } from '@/ui/components/ToastRegion';
import { Resizer } from '@/ui/layout/Resizer';
import { ErrorBoundary } from '@/ui/components/ErrorBoundary';
import styles from './App.module.css';

export function App() {
  const leftVisible = useUiStore((state) => state.leftPanelVisible);
  const rightVisible = useUiStore((state) => state.rightPanelVisible);
  const bottomVisible = useUiStore((state) => state.bottomPanelVisible);
  const developerVisible = useDeveloperStore((state) => state.visible);

  const activeMode = useUiStore((state) => state.activeMode);
  const panelSizes = useUiStore((state) => state.panelSizes);
  const theme = useUiStore((state) => state.theme);

  // Hide design-specific panels during simulation or workshop mode
  const showLeftPanel = leftVisible && activeMode !== 'simulation' && activeMode !== 'workshop';
  const showRightPanel = rightVisible && activeMode !== 'simulation' && activeMode !== 'workshop';
  const showBottomPanel = bottomVisible && activeMode !== 'workshop';

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  return (
    <div className={styles.appShell}>
      <AppToolbar />

      <ErrorBoundary fallbackTitle="Çalışma Alanında Bir Sorun Oluştu">
        <div className={styles.mainLayout}>
          {showLeftPanel && (
            <>
              <div style={{ width: panelSizes.left, flexShrink: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                {activeMode === 'program' ? <Toolbox /> : activeMode === 'hmi' ? <HMIToolbox /> : <ComponentsPanel />}
              </div>
              <Resizer panel="left" orientation="horizontal" />
            </>
          )}

          <main className={styles.centerArea}>
            {activeMode === 'program' ? (
              <LadderCanvas />
            ) : activeMode === 'hmi' ? (
              <HMIEditor />
            ) : activeMode === 'workshop' ? (
              <WorkshopView />
            ) : (
              <SceneView />
            )}
            {activeMode !== 'hmi' && activeMode !== 'workshop' && <HMIRuntimeWindow />}
            {showBottomPanel && (
              <>
                <Resizer panel="bottom" orientation="vertical" />
                <BottomPanel />
              </>
            )}
          </main>

          {showRightPanel && (
            <>
              <Resizer panel="right" orientation="horizontal" />
              <div style={{ width: panelSizes.right, flexShrink: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <PropertiesPanel />
              </div>
            </>
          )}
        </div>
      </ErrorBoundary>

      <StatusBar />

      {developerVisible && <DeveloperPanel />}
      
      <ToastRegion />
    </div>
  );
}
